<div id="inquiries-by-request-type-box" style="width: 100%;min-height: 280px;overflow: hidden;">
    <div id="inquiries-by-request-type" class="dashboardChart"></div>
    <fading-dialog [chartId]= "'requestTypeDialog'" #requestTypeDialog></fading-dialog>
</div>
